export default __webpack_public_path__ + "static/media/Icons-42.2748e4e5.png";